import {cloneDeep as _cloneDeep} from 'lodash';
import DashboardModel from "./../../models/DashboardModel"
const DashboardModule = {
    namespaced: true,
    state: () => ({
        dashboard: _cloneDeep(DashboardModel),
    }),
    getters: {
        getDashboard (state) {
            return state.dashboard
        },
    },
    mutations: {
        setDashboard (state, payload) {
            state.dashboard = payload
        },
    },
    actions: {
        setDashboard (context, payload) {
            context.commit('setDashboard', payload);
        },
    },

}

export default DashboardModule;
